import { axiosInstance } from './axiosConfig';
import { handleRequestWithAuth } from './refreshService';

const API_URL = 'blog-categoria/'; 

export interface Categoria {
    id: number;
    nombre: string;
    slug: string;
    descripcion: string | null;
    creado_en: string;
    cantidad_publicaciones: number;
}

// GET: Obtener todas las categorías
export const fetchCategorias = async (): Promise<Categoria[]> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get<Categoria[]>(API_URL);
        return response.data;
    });
};

// GET: Obtener una categoría por ID
export const fetchCategoria = async (id: number): Promise<Categoria> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get<Categoria>(`${API_URL}${id}/`);
        return response.data;
    });
};

// POST: Crear una nueva categoría
export const createCategoria = async (data: {
    nombre: string;
    descripcion?: string;
}) => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.post(API_URL, data);
        return response.data;
    });
};

// PUT: Actualizar una categoría existente
export const updateCategoria = async (
    id: number,
    data: {
        nombre?: string;
        descripcion?: string | null;
    }
) => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.put(`${API_URL}${id}/`, data);
        return response.data;
    });
};

// DELETE: Eliminar una categoría
export const deleteCategoria = async (id: number) => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.delete(`${API_URL}${id}/`);
        return response.data;
    });
};